import { defineStore } from 'pinia'
export default defineStore({
  id: 'routeDataTable',
  persist: true,
  state: () => {
    return {
      isRouteArchive: false,
      isRouteDocuementArchive: false
    }
  },
  actions: {
    setIsRouteDocumentArchive: function (payload: any) {
      this.isRouteDocuementArchive = payload
    },
    setIsRouteArchive: function (payload: any) {
      this.isRouteArchive = payload
    }
  },
  getters: {
    getIsRouteDocumentArchive: (state: any) => state.isRouteDocuementArchive,
    getIsRouteArchive: (state: any) => state.isRouteArchive
  }
})
